const t = {
  name: "Monitoring",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,2C2.5,2,2,2.5,2,3v10H0V3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v24c0,1.7-1.3,3-3,3H24.2l0.7,4H28v2H12v-2
			h3.2l0.7-4H3c-1.7,0-3-1.3-3-3V17h4.4l3-5h2.2l4.9,8.8L21.4,6h2.3l5,11H34v2h-6.6L22.5,8.3L15.6,23h-2.2l-4.9-8.9L5.6,19H2v8
			c0,0.5,0.5,1,1,1h34c0.5,0,1-0.5,1-1V3c0-0.5-0.5-1-1-1H3z M17.8,30l-0.7,4h5.6l-0.7-4H17.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Monitoring
};
